import Guid from "../../helpers/guid";
import Notification from "./notification";
import {NotificationDeliveryMethod} from "~/enums/notificationDeliveryMethod";
import {DurationUnit} from "../../enums/durationUnit";
import BuilderModel from "~/models/tracked/builderModel";
import {DefaultEmailStyle} from "~/enums/defaultEmailStyle";

export default class NotificationFactory {
  static create(parent: BuilderModel, notificationType = Notification ) {
    const notification: Notification = new notificationType();
    notification.rootModel = parent.rootModel;
    notification.defineProperty('client_id', Guid.create());
    notification.defineProperty('target_action_client_id', null);
    notification.defineProperty('subject', '');
    notification.defineProperty('body', '');
    notification.defineProperty('email_style', DefaultEmailStyle.Default);
    notification.defineProperty('is_after', false);
    notification.defineProperty('relative_to', null);
    notification.defineProperty('relative_amount', 0);
    notification.defineProperty('relative_unit', DurationUnit.hour);
    notification.defineProperty('delivery_methods', [NotificationDeliveryMethod.ViaInSystem]);
    notification.defineProperty('linked_detail_view_id', '');
    notification.defineProperty('author', '');
    notification.defineProperty('document_type', '');
    notification.defineProperty('note_id', '');

    return notification;
  }
}